<template>
  <div class="sousuo">
    <img class="input_bj" src="../assets/h2.png" alt="">
    <div class="sousuo_flex">
      <el-select class="sousuo_select" v-model="select_type" value-key="text" placeholder="请选择" suffix-icon="CaretBottom">
        <el-option
          v-for="(item, index) in select_array"
          :key="index"
          :label="item.text"
          :value="item"
        />
      </el-select>
      <div class="sousuo_xian"></div>
      <div class="flex">
        <el-input
          v-model="keywords"
          placeholder=""
          clearable
        />
        <span class="sousuo_hover" style="cursor: pointer;" @click="bindsousuochange()">搜索</span>
      </div>
      <div class="sousuo_xian"></div>
      <div class="gaojijiansuo" @click.stop="bindsenior_offchange()">高级检索</div>
    </div>
  </div>
  <!-- 高级检索弹窗 开始 -->
  <div class="senior" v-if="seniorPopup" @click.stop="bindsenior_offchange()">
    <div class="senior_popup" @click.stop="bindfangchuantouchange()">
      <div class="senior_list" v-for="(item, index) in seniorList" :key="index">
        <div class="senior1">
          <span v-if="index == 0">检索信息</span>
          <el-select v-if="index > 0" class="senior_select" v-model="item.relationship" value-key="name" placeholder="请选择" suffix-icon="CaretBottom">
            <el-option v-for="item in relationshipArray" :key="item.id" :label="item.name" :value="item" />
          </el-select>
        </div>
        <div class="senior2">
          <el-select class="senior2_select" v-model="item.select_type" value-key="text" placeholder="请选择" suffix-icon="CaretBottom">
            <el-option v-for="(item, index) in select_typeArray" :key="index" :label="item.text" :value="item" />
          </el-select>
          <div class="senior2_shuxian"></div>
          <el-input class="senior2_input" v-model="item.senior_keyword" placeholder="请输入搜索关键词" />
        </div>
        <div class="senior3">
          <el-select class="senior_select" v-model="item.accuracy" value-key="name" placeholder="请选择" suffix-icon="CaretBottom">
            <el-option v-for="item in accuracyArray" :key="item.id" :label="item.name" :value="item" />
          </el-select>
        </div>
        <div class="senior4" v-if="index == 0" @click.stop="bindjiajianchange('jia', index)"><el-icon><Plus /></el-icon></div>
        <div class="senior4" v-if="index > 0" @click.stop="bindjiajianchange('jian', index)"><el-icon><Minus /></el-icon></div>
      </div>
      <div class="serior_btn" @click.stop="bindjiansuochange()">检索</div>
    </div>
  </div>
  <!-- 高级检索弹窗 结束 -->
</template>
<script setup>
  import { reactive, ref, onMounted } from 'vue';
  import { post } from '@/services/api';
  import { ElMessage } from 'element-plus';
  import { useRouter, useRoute } from "vue-router";
  const router = useRouter();
  const route = useRoute();

  const props = defineProps({
    // 检索词
    field1: {
      type: String,
      default: "",
    },
    fieldname1: {
      type: String,
      default: "",
    },
    // 检索值
    keywords1: {
      type: String,
      default: "",
    },
    // 高级检索JSON
    senior_json1: {
      type: String,
      default: "",
    },
  });

  var {field1, fieldname1, keywords1, senior_json1} = reactive(props);
  
  // 定义子组件的 `emit` 事件
  const emit = defineEmits(['search_change']);
  
  const select_array = reactive([]);
  const select_type = ref({
    field: field1,
    text: fieldname1,
  });
  const keywords = ref(keywords1);

  // 高级检索，检索条件
  const seniorPopup = ref(false);
  const seniorList = reactive([
    {
      relationship: {
        id: 1,
        name: '与',
        huo: 'and',
      }, // 搜素条件关系
      select_type: select_array[0], // 搜索类型
      senior_keyword: '', // 关键词
      accuracy: {
        id: 1,
        name: '模糊',
        tiaojian: 'like',
      },  // 精度
    },
  ]);
  const relationshipArray = reactive([
    {
      id: 1,
      name: '或',
      huo: 'or',
    },
    {
      id: 2,
      name: '与',
      huo: 'and',
    },
    {
      id: 3,
      name: '非',
      huo: 'no',
    },
  ]);
  const select_typeArray = reactive([]);
  const accuracyArray = reactive([
    {
      id: 1,
      name: '模糊',
      tiaojian: 'like',
    },
    {
      id: 1,
      name: '精准',
      tiaojian: '=',
    },
  ]);
  // 防穿透
  const bindfangchuantouchange=()=>{};
  // 监听开启\关闭高级检索弹窗
  const bindsenior_offchange=()=>{
    if(!seniorPopup.value){
      if(senior_json1 != "" && JSON.parse(senior_json1).length > 0){
        seniorList.splice(0, seniorList.length, ...JSON.parse(senior_json1));
      }
      seniorPopup.value = true;
    }else{
      seniorPopup.value = false;
    }
  };
  // 增加/减少高级检索条件
  const bindjiajianchange=(type, index)=>{
    switch (type) {
      case 'jia':
        if(seniorList.length >= 5){
          ElMessage({
            message: '最多添加五个检索条件',
            type: 'warning',
          })
          return
        }
        var linshi_jia_array = {
          relationship: {
            id: 1,
            name: '或',
            huo: 'or',
          }, // 搜素条件关系
          select_type: select_array[0], // 搜索类型
          senior_keyword: '', // 关键词
          accuracy: {
            id: 1,
            name: '模糊',
            tiaojian: 'like',
          },  // 精度
        };
        seniorList.push(linshi_jia_array);
        break;
    
      case 'jian':
        seniorList.splice(index, 1);
        break;
    }
  };
  
  onMounted(() => {
    // 在组件挂载时调用 API 获取数据
    getField();
  });
  // 获取下拉检索词
  const getField = async () => {
    try {
      const response = await post("/api/book/getfield"); // 发送请求
      // 请求成功
      select_array.splice(0, select_array.length, ...response.data);
      if(field1 == ""){
        select_type.value = select_array[0];
      }
      select_typeArray.splice(0, select_typeArray.length, ...response.data);
    } catch (err) {
      // 请求失败
      ElMessage({
        message: err,
        type: 'error',
      })
    } finally {
      // 请求结束
    }
  };
  // 搜索
  const bindsousuochange=async()=>{
    // 获取当前路径
    const currentPath = route.path;
    console.log(currentPath)
    // 首页携带参数跳转至古籍页
    if(currentPath == "/"){
      router.push({
        name: "AncientWorks",
        query: {
          field1: select_type.value.field,
          fieldname1: select_type.value.text,
          keywords1: keywords.value,
          senior_json1: seniorList[0].senior_keyword != '' ? JSON.stringify(seniorList) : "",
        }
      })
    }else{
      // 古籍页子组件向父组件传参
      const field1 = select_type.value.field;
      const fieldname1 = select_type.value.text;
      const keywords1 = keywords.value;
      const senior_json1 = seniorList[0].senior_keyword != '' ? JSON.stringify(seniorList) : "";
      emit('search_change', field1, fieldname1, keywords1, senior_json1);
    }
  };
  // 高级检索
  const bindjiansuochange=()=>{
    // 获取当前路径
    const currentPath = route.path;
    console.log(currentPath)
    // 首页携带参数跳转至古籍页
    if(currentPath == "/"){
      seniorPopup.value = false;
      router.push({
        name: "AncientWorks",
        query: {
          field1: select_type.value.field,
          fieldname1: select_type.value.text,
          keywords1: keywords.value,
          senior_json1: seniorList[0].senior_keyword ? JSON.stringify(seniorList) : "",
        }
      })
    }else{
      // 古籍页子组件向父组件传参
      const field1 = select_type.value.field;
      const fieldname1 = select_type.value.text;
      const keywords1 = keywords.value;
      senior_json1 = seniorList[0].senior_keyword ? JSON.stringify(seniorList) : "";
      emit('search_change', field1, fieldname1, keywords1, senior_json1);
      seniorPopup.value = false;
    }
  };
</script>
<style scoped>
.sousuo{
  width:max-content;
  height: 83px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.input_bj{
  width: 100%;
  height: 100%;
  position: absolute;
}
/* select 开始 */
.sousuo_flex{
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  font-weight: 400;
  font-size: 16px;
  color: #413E39;
}
.sousuo_select{
  width: 121px;
  border: none;
  margin-left: 10px;
}
:deep(.sousuo_select .el-select__wrapper){
  height: 100%;
  border: none;
  background-color: transparent;
  box-shadow: none;
  font-weight: 400;
  font-size: 16px;
  color: #413E39;
  text-align: center;
}
/* select 结束 */
/* input框 开始 */
.sousuo_flex .el-input{
  width: 558px;
  border: none;
}
:deep(.el-input__wrapper){
  border: none;
  background-color: transparent;
  box-shadow: none;
}
:deep(.el-input__inner){
  font-weight: 400;
  font-size: 16px;
  color: #413E39;
}
/* input框 结束 */
.sousuo_xian{
  width: 1px;
  height: 23px;
  background-color: #413E39;
  margin: 0 20px 0 20px;
}
.sousuo_hover:hover{
  color: #000000;
}
.gaojijiansuo{
  padding-right: 30px;
  font-weight: 400;
  font-size: 16px;
  color: #413E39;
  cursor: pointer;
}
.gaojijiansuo:hover{
  color: #000000;
}
@media (min-width: 750px) and (max-width: 1200px) {
  .sousuo_flex .el-input{
    width: 325px;
  }
}
@media (min-width: 450px) and (max-width: 750px) {
  .sousuo{
    height: 50px;
  }
  .sousuo_flex .el-input{
    width: 120px;
  }
}
@media screen and (max-width: 450px) {
  .sousuo{
    height: 42px;
  }
  .sousuo_select{
    width: 68px;
  }
  .sousuo_flex{
    font-size: 12px;
  }
  .sousuo_flex .el-input{
    width: 152px;
  }
  .sousuo_xian{
    width: 1px;
    height: 14px;
    margin: 0 9px 0 9px;
  }
  :deep(.sousuo_select .el-select__wrapper){
    padding: 0;
    font-size: 12px;
  }
  :deep(.el-input__inner){
    font-size: 12px;
  }
  .gaojijiansuo{
    font-size: 12px;
    padding-right: 10px;
  }
}
/* 高级检索弹窗 开始 */
.senior{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.senior_popup{
  max-width: 1600px;
  padding: 50px 80px 40px 80px;
  background-color: #FCFBF7;
  box-shadow: 0px 4px 16px 0px rgba(64,63,61,0.15);
  border-radius: 2px;
}
.senior_list{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.senior_list:nth-child(1){
  margin-top: 0;
}
.senior1{
  width: 120px;
  height: 60px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  font-size: 18px;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
}
.senior_select{
  width: 100%;
  height: 100%;
  border: none;
}
:deep(.senior_select .el-select__wrapper){
  height: 100%;
  border: none;
  background-color: transparent;
  box-shadow: none;
  font-weight: 400;
  font-size: 18px;
  color: #413E39;
  text-align: center;
}
.senior2{
  width: 1080px;
  height: 60px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.senior2_select{
  width: 115px;
  height: 100%;
}
:deep(.senior2_select .el-select__wrapper){
  height: 100%;
  border: none;
  background-color: transparent;
  box-shadow: none;
  font-weight: 400;
  font-size: 18px;
  color: #413E39;
  text-align: center;
}
.senior2_shuxian{
  width: 1px;
  height: 40px;
  background-color: #EAEAEA;
}
.senior2_input{
  width: calc(100% - 126px);
}
:deep(.senior2_input .el-input__wrapper){
  border: none;
  background-color: transparent;
  box-shadow: none;
}
:deep(.senior2_input .el-input__inner){
  font-weight: 400;
  font-size: 18px;
  color: #413E39;
}
.senior3{
  width: 120px;
  height: 60px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  margin-left: 20px;
}
.senior4{
  width: 60px;
  height: 60px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  margin-left: 20px;
  font-size: 22px;
  color: #222222;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.serior_btn{
  width: 160px;
  height: 60px;
  background-color: #DBD5C6;
  border-radius: 50px;
  font-size: 18px;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto 0;
  cursor: pointer;
}
@media (min-width: 1200px) and (max-width: 1600px) {
  .senior2{
    width: 680px;
  }
}
@media (min-width: 750px) and (max-width: 1200px) {
  .senior_popup{
    padding: 40px 30px 40px 30px;
  }
  .senior2{
    width: 300px;
  }
}
@media screen and (max-width: 750px) {
  .senior_popup{
    max-width: 702px;
    padding: 30px 20px 30px 20px;
    box-shadow: 0px 4px 16px 0px rgba(64,63,61,0.15);
    border-radius: 10px;
  }
  .senior1{
    width: 120px;
    height: 70px;
    font-size: 24px;
  }
  :deep(.senior_select .el-select__wrapper){
    font-size: 24px;
  }
  .senior2{
    width: 346px;
    height: 70px;
    margin-left: 14px;
  }
  .senior2_select{
    width: 100px;
    height: 100%;
  }
  :deep(.senior2_select .el-select__wrapper){
    font-size: 24px;
  }
  .senior2_input{
    width: calc(100% - 101px);
  }
  :deep(.senior2_input .el-input__inner){
    font-size: 24px;
  }
  .senior3{
    width: 98px;
    height: 70px;
    margin-left: 12px;
  }
  .senior4{
    width: 60px;
    height: 70px;
    margin-left: 12px;
    font-size: 30px;
  }
  .serior_btn{
    width: 200px;
    height: 80px;
    background-color: #DBD5C6;
    border-radius: 50px;
    font-size: 30px;
    color: #222222;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 0;
    cursor: pointer;
  }
}
@media (min-width: 600px) and (max-width: 750px) {
  .senior_popup{
    max-width: 562px;
    padding: 24px 16px 24px 16px;
    box-shadow: 0px 3px 13px 0px rgba(64,63,61,0.15);
    border-radius: 8px;
  }
  .senior1{
    width: 96px;
    height: 56px;
    font-size: 19px;
  }
  :deep(.senior_select .el-select__wrapper){
    font-size: 19px;
  }
  .senior2{
    width: 276px;
    height: 56px;
    margin-left: 11px;
  }
  .senior2_select{
    width: 80px;
    height: 100%;
  }
  :deep(.senior2_select .el-select__wrapper){
    font-size: 19px;
  }
  .senior2_input{
    width: calc(100% - 81px);
  }
  :deep(.senior2_input .el-input__inner){
    font-size: 19px;
  }
  .senior3{
    width: 78px;
    height: 56px;
    margin-left: 9.6px;
  }
  .senior4{
    width: 48px;
    height: 56px;
    margin-left: 9.6px;
    font-size: 24px;
  }
  .serior_btn{
    width: 160px;
    height: 64px;
    background-color: #DBD5C6;
    border-radius: 40px;
    font-size: 24px;
    color: #222222;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px auto 0;
    cursor: pointer;
  }
}
@media (min-width: 450px) and (max-width: 600px) {
  .senior_popup{
    max-width: 421px;
    padding: 18px 12px 18px 12px;
    box-shadow: 0px 3px 10px 0px rgba(64,63,61,0.15);
    border-radius: 6px;
  }
  .senior1{
    width: 72px;
    height: 42px;
    font-size: 14px;
  }
  :deep(.senior_select .el-select__wrapper){
    font-size: 14px;
  }
  .senior2{
    width: 207px;
    height: 42px;
    margin-left: 7.4px;
  }
  .senior2_select{
    width: 60px;
    height: 100%;
  }
  :deep(.senior2_select .el-select__wrapper){
    font-size: 14px;
  }
  .senior2_input{
    width: calc(100% - 61px);
  }
  :deep(.senior2_input .el-input__inner){
    font-size: 14px;
  }
  .senior3{
    width: 59px;
    height: 42px;
    margin-left: 7px;
  }
  .senior4{
    width: 36px;
    height: 42px;
    margin-left: 7px;
    font-size: 18px;
  }
  .serior_btn{
    width: 120px;
    height: 48px;
    background-color: #DBD5C6;
    border-radius: 30px;
    font-size: 18px;
    color: #222222;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 18px auto 0;
    cursor: pointer;
  }
}
@media screen and (max-width: 450px) {
  .senior_popup{
    max-width: 351px;
    padding: 15px 10px 15px 10px;
    box-shadow: 0px 2px 8px 0px rgba(64,63,61,0.15);
    border-radius: 5px;
  }
  .senior1{
    width: 60px;
    height: 35px;
    font-size: 12px;
  }
  :deep(.senior_select .el-select__wrapper){
    font-size: 12px;
  }
  .senior2{
    width: 173px;
    height: 35px;
    margin-left: 7px;
  }
  .senior2_select{
    width: 50px;
    height: 100%;
  }
  :deep(.senior2_select .el-select__wrapper){
    font-size: 12px;
  }
  .senior2_input{
    width: calc(100% - 51px);
  }
  :deep(.senior2_input .el-input__inner){
    font-size: 12px;
  }
  .senior3{
    width: 49px;
    height: 35px;
    margin-left: 6px;
  }
  .senior4{
    width: 30px;
    height: 35px;
    margin-left: 6px;
    font-size: 15px;
  }
  .serior_btn{
    width: 100px;
    height: 40px;
    background-color: #DBD5C6;
    border-radius: 25px;
    font-size: 15px;
    color: #222222;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px auto 0;
    cursor: pointer;
  }
}
/* 高级检索弹窗 结束 */
</style>
